// store/autoDebugSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AutoDebugState {
  enabled: boolean;
  count: number; // number of completed attempts
  running: boolean;
  previewJustLoaded: boolean; // true between iframe onLoad and first new error after that load
}

const initialState: AutoDebugState = {
  enabled: false,
  count: 0,
  running: false,
  previewJustLoaded: false,
};

const autoDebugSlice = createSlice({
  name: "autoDebug",
  initialState,
  reducers: {
    setAutoDebugEnabled: (state, action: PayloadAction<boolean>) => {
      state.enabled = action.payload;
      if (!action.payload) {
        state.count = 0; // reset when turned off
        state.running = false;
        state.previewJustLoaded = false;
      }
    },
    incrementAutoDebugCount: (state) => {
      if (state.count < 3) state.count += 1;
    },
    resetAutoDebugCount: (state) => {
      state.count = 0;
    },
    setAutoDebugRunning: (state, action: PayloadAction<boolean>) => {
      state.running = action.payload;
    },
    setPreviewJustLoaded: (state, action: PayloadAction<boolean>) => {
      state.previewJustLoaded = action.payload;
    },
  },
});

export const {
  setAutoDebugEnabled,
  incrementAutoDebugCount,
  resetAutoDebugCount,
  setAutoDebugRunning,
  setPreviewJustLoaded,
} = autoDebugSlice.actions;

export default autoDebugSlice.reducer;
